import {
    PaperBtcUsdt,
    PaperExchange,
  } from "../../../../Const";
import { isLockedDayTraderTemplate } from "../../../../utils/Utils";
  
export const adaptBotPreset = (
  exchange = PaperExchange,
  exchangePair = PaperBtcUsdt,
) => {
  const pair = exchangePair.pair || {};
  
  return {
    id: null,
    name: "New Bot",
    exchange: exchange,
    exchangePairId: exchangePair.id, //exchange_pair.id
    pair: exchangePair.pair,
    initFund: 0,
    baseCoin: pair.from,
    quoteCoin: pair.to,
    tradeOrderType: "market",
    tradeOrderTypeExit: "market",
    stopLossDisabled: 0,
   
  };
};
export const adaptRentBotEdit = (
  bot
) => {
  const pair = bot.exchange_pair.pair || {};
  const rentBot = {
    template_id: bot.template_id ?? bot.template?.id,
    rental:
      bot.rental ||
      (bot.template || bot.template_id || bot.template_name
        ? {
            template: {
              ...(bot.template || {}),
              id: bot.template?.id ?? bot.template_id,
              title: bot.template?.title ?? bot.template_name,
              strategy: bot.template?.strategy ?? bot.strategy,
            },
          }
        : {}),
  };
  return {
    id: bot.id,
    rent_id: bot.rent_id,
    ...rentBot,
    name: bot.name,
    exchange: bot.exchange_pair.exchange,
    exchangePairId: bot.exchange_pair_id, //exchange_pair.id
    pair: bot.exchange_pair.pair,
    initFund: bot.initial_fund,
    baseCoin: pair.from,
    quoteCoin: pair.to,
    strategy: bot.strategy,
    isEditing: true,
    createBotStart:true,
    closeDealEndOfTradingDay:isLockedDayTraderTemplate(rentBot) ? 1 : bot.end_day_auto_close,
    extendedTradingHour: bot.extended_trading_hour,
    tradingHour247:bot.trading_hour_247,
    disableFractionPurchase:bot.fractional_trading_disabled,
    stopLossDisabled:bot.stop_loss_disabled,
    tradeOrderType:bot.order_type,
    tradeOrderTypeExit:bot.order_type_exit,
    is247: bot.exchange_pair.is_247,
    stopBotAfterDeal: bot.disable_after_deal_closed,
    sendOrderFilledEmail: bot.order_filled_email_enabled,
    sendOrderFilledPhone: bot.order_filled_phone_enabled ?? 1,
    baseOrderType: bot.base_order_type,
    futureMaxContracts: bot.configs && bot.configs.future_max_contracts,
    takeProfit: bot.profit ?? 0,
    stoploss: bot.stop_loss ?? 0,
    minTp: bot.min_tp ?? "",
    extraPriceGapMin: bot.extra_price_gap_min ?? "",
    templateExitConditions: bot.template_exit_conditions || {},
    effectiveExitConditions: bot.effective_exit_conditions || {},
    marketplaceExitConditionsModified: Boolean(bot.marketplace_exit_conditions_modified)
  };
};
export const adaptRentBotDefault = (
  exchange = PaperExchange,
  exchangePair = PaperBtcUsdt,rental
) => {
  const pair = exchangePair.pair || {};
  const isLockedTemplate = isLockedDayTraderTemplate({ rental });
  return {
    id: null,
    name: "New Bot",
    exchange: exchange,
    exchangePairId: exchangePair.id, //exchange_pair.id
    pair: exchangePair.pair,
    initFund: 0,
    baseCoin: pair.from,
    quoteCoin: pair.to,
    rent_id: rental.id,
    rental,
    isEditing: false,
    is247: exchangePair.is_247,
    sendOrderFilledEmail:1,
    sendOrderFilledPhone:0,
    tradeOrderType: "market",
    tradeOrderTypeExit: "market",
    futureMaxContracts: 0,
    stopLossDisabled:0,
    takeProfit: 0,
    stoploss: 0,
    minTp: "",
    extraPriceGapMin: "",
    templateExitConditions: {},
    effectiveExitConditions: {},
    marketplaceExitConditionsModified: false,
    closeDealEndOfTradingDay: isLockedTemplate ? 1 : 0,
    extendedTradingHour: 0,
  };
};
  
